export default __webpack_public_path__ + "static/media/AKM_9.4318dbd6.png";